import React from "react";
import paradox from '../assests/paradox.png'
import "./About.css"
import Footer from "../Footer/Footer";

const About = () => {
  return (
    <>
      <div className="bg">
        <div className="container">
          <div className="main-container">
            <div>
              <div className="header">
                <h1>ABOUT US</h1>
              </div>
              <div className="main-content">
     <p className="malhaar-text">
     MALHAAR is more than a fest; it is a decade-long legacy of
                        excellence at BPIT. This annual extravaganza isn't confined to our
                        campus; it is a magnetic force that 
                        draws students from over 4 colleges.Students find the platform to manifest their dreams whether through technological wizardry, literary prowess,
                        managerial acumen or rich and diverse cultural expressions.
                        Even in the face of the daunting challenges posed by COVID-19,
                        MALHAAR defied the odds, drawing a massive crowd of 30,000+
                        attendees. The electrifying performance by the renowned
                        "PARADOX" left the audience spellbound and yearning for more. As
                        we embark on a new year, our hearts brim with anticipation, eager
                        to invite blooming artists from the vast canvas of the industry.
                        Over the years, luminaries like Olly Esse, Fazilpuria, Deep Money
                        and Sukhe have graced our stage. It's a testament to our journey,
                        from being known as "CORONA" to MALHAAR, where we continue
                        to shine and inspire.
                </p>

                <div className="second-content">
                  <div className="second-text">
                    <img src={ paradox } alt="About Image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    </>
  );
};

export default About;
